import { OpportunityType } from './Opportunity.enum';
import Enumerator from '../global/Enumerator';

export const opportunityContextualTypes = [
  'property_investment_landlord',
  'property_investment_agents',
  'asset_vehicle_advocacy',
  'asset_vehicle_finance',
  'asset_vehicle_warranty',
  'objective_purchase_property_solicitor',
  'objective_purchase_property_certificate',
  'objective_purchase_property_utility',
  'objective_purchase_property_car_advocacy',
  'objective_purchase_property_car_finance',
  'objective_purchase_property_rental',
  'objective_purchase_property_protection',
  'objective_purchase_deposit_guarantee',
  'objective_purchase_building_services',
  'objective_mitigate_risk',
  'objective_will',
  'objective_credit_history',
  'objective_mortgage_protection',
  'objective_additional_planning',
  'objective_additional_property_advocacy',
  'objective_additional_investment',
  'objective_additional_health',
  'self_employed_invoice_finance',
  'self_employed_indemnity_cover'
];

export class OpportunityContextualType extends Enumerator {
  static default() {
    return this.of('property_investment_landlord');
  }
}

OpportunityContextualType.initEnum({
  property_investment_landlord: {
    get title() {
      return 'Client has an investment property. Have you discussed LANDLORD PROTECTION COVER?';
    },
    get type() {
      return OpportunityType.landlord_protection.name;
    }
  },
  property_investment_agents: {
    get title() {
      return 'Client has an investment property. Have you discussed alternative RENTAL AGENTS?';
    },
    get type() {
      return OpportunityType.rental_agency.name;
    }
  },
  asset_vehicle_advocacy: {
    get title() {
      return "Client's vehicle is over two years old. Does the client require a free assistance with a CAR BUYER ADVOCACY?";
    },
    get type() {
      return OpportunityType.car_buyers_advocacy.name;
    }
  },
  asset_vehicle_finance: {
    get title() {
      return "Client's vehicle is over two years old. Does the client require ASSET FINANCE for the next purchase?";
    },
    get type() {
      return OpportunityType.car_asset_finance.name;
    }
  },
  asset_vehicle_warranty: {
    get title() {
      return 'Have you discussed ADDITIONAL WARRANTY for the current vehicle?';
    },
    get type() {
      return OpportunityType.additional_car_warranty.name;
    }
  },
  objective_purchase_property_solicitor: {
    get title() {
      return 'Client is purchasing a property and will require a solicitor to assist with the CONVEYANCING and complete loan settlement.';
    },
    get type() {
      return OpportunityType.conveyancing_settlement_agency.name;
    }
  },
  objective_purchase_property_certificate: {
    get title() {
      return 'Client is purchasing a property and will require a CERTIFICATE OF CURRENCY/HOME AND CONTENTS insurance to complete loan settlement.';
    },
    get type() {
      return OpportunityType.home_and_contents.name;
    }
  },
  objective_purchase_property_utility: {
    get title() {
      return 'Client is purchasing a property. Have you discussed a complimentary UTILITY CONNECTION/RELOCATION SERVICE?';
    },
    get type() {
      return OpportunityType.utility_connection_service.name;
    }
  },
  objective_purchase_property_rental: {
    get title() {
      return 'Client is buying/refinancing an investment property. Have you discussed a referral to a RENTAL AGENT?';
    },
    get type() {
      return OpportunityType.rental_agency.name;
    }
  },
  objective_purchase_property_protection: {
    get title() {
      return 'Client is buying/refinancing an investment property. Have you discussed LANDLORD PROTECTION COVER?';
    },
    get type() {
      return OpportunityType.landlord_protection.name;
    }
  },
  objective_purchase_property_car_advocacy: {
    get title() {
      return 'Client is purchasing a property and might require CAR BUYING ADVOCACY.';
    },
    get type() {
      return OpportunityType.car_buyers_advocacy.name;
    }
  },
  objective_purchase_property_car_finance: {
    get title() {
      return 'Client is purchasing a property and might require CAR FINANCE service.';
    },
    get type() {
      return OpportunityType.car_asset_finance.name;
    }
  },
  objective_purchase_deposit_guarantee: {
    get title() {
      return 'Client is purchasing a property and might require DEPOSIT GUARANTEE.';
    },
    get type() {
      return OpportunityType.deposit_guarantee.name;
    }
  },
  objective_purchase_building_services: {
    get title() {
      return 'Client is purchasing a property. Have you discussed a referral to BUILDING SERVICES providers?';
    },
    get type() {
      return OpportunityType.building_services.name;
    }
  },
  objective_mitigate_risk: {
    get title() {
      return 'Client requires adequate insurance to mitigate risk. Have you discussed INSURANCE options with the client?';
    },
    get type() {
      return OpportunityType.risk_insurance.name;
    }
  },
  objective_will: {
    get title() {
      return "Client doesn't have adequate estate plan in place. Have you discussed ESTATE PLANNING options with the client?";
    },
    get type() {
      return OpportunityType.estate_planning.name;
    }
  },
  objective_credit_history: {
    get title() {
      return 'Client has indicated that they have some credit issue that might require a CREDIT REPAIR. Have you discussed options with the client?';
    },
    get type() {
      return OpportunityType.credit_repair_agency.name;
    }
  },
  objective_mortgage_protection: {
    get title() {
      return 'Client might require a MORTGAGE PROTECTION INSURANCE.';
    },
    get type() {
      return OpportunityType.mortgage_protection_insurance.name;
    }
  },
  objective_additional_planning: {
    get title() {
      return 'Client indicated that they would like further assistance with INVESTMENT, SUPERANNUATION AND FINANCIAL PLANNING.';
    },
    get type() {
      return OpportunityType.investment_superannuation_and_financial_planning.name;
    }
  },
  objective_additional_property_advocacy: {
    get title() {
      return 'Client indicated that they would like further assistance with the PROPERTY BUYING ADVOCACY.';
    },
    get type() {
      return OpportunityType.property_buyers_advocacy.name;
    }
  },
  objective_additional_investment: {
    get title() {
      return 'Client indicated that they would like further assistance with PROPERTY INVESTMENT.';
    },
    get type() {
      return OpportunityType.property_investment_services.name;
    }
  },
  objective_additional_health: {
    get title() {
      return 'Client indicated that they would like further assistance with HEALTH COVER.';
    },
    get type() {
      return OpportunityType.health_cover.name;
    }
  },
  self_employed_invoice_finance: {
    get title() {
      return 'Client is self employed. Have you discussed INVOICE FINANCE/CASH flow options available?';
    },
    get type() {
      return OpportunityType.invoice_financing.name;
    }
  },
  self_employed_indemnity_cover: {
    get title() {
      return 'Client is self employed. Have you discussed PROFESSIONAL INDEMNITY COVER options?';
    },
    get type() {
      return OpportunityType.professional_indemnity_cover.name;
    }
  }
});

export default {
  opportunityContextualTypes,
  OpportunityContextualType
};
